import { ApiLoginPatientResponse, ApiSearchUsersResponse, MockResponseFunc } from 'src/app/core/models';

export const loginPatient = (): ApiLoginPatientResponse => {
  return {
    id: 1,
    sessionId: 1,
  };
};

export const searchUsers = (): ApiSearchUsersResponse[] => {
  return [
    {
      oktaId: '0098781234',
      patients: [
        {
          patientId: 1000,
          createdAt: '2018-11-14T00:55:31',
          lastSessionAt: '2019-11-14T00:55:31',
          isLegacyUser: true,
        },
        {
          patientId: 1001,
          createdAt: '2019-11-14T00:55:31',
          isLegacyUser: false,
        },
        {
          patientId: 1002,
          createdAt: '2019-11-14T00:55:31',
          lastSessionAt: '2019-11-14T00:55:31',
          isLegacyUser: false,
        },
      ],
    },
  ];
};

export const revokePreviousTokens = () => {};

export const updatePassword = () => {};
